<template>
  <div class="quote-acceptance-modal">
    <b-overlay :show="loading" rounded="sm">
      <div class="quote-acceptance-content">
        <div class="quote-acceptance__header">
          <div class="quote-acceptance__title">
            <h3>{{ $t("carriers.modalInfo.quoteAcceptance") }}</h3>
          </div>
          <div class="quote-acceptance__button">
            <button @click="closeModal" class="close-button">
              <i class="ion ion-close-circle-outline close-button__icon"></i>
            </button>
          </div>
        </div>
        <hr class="mb-2" />
        <div class="quote-acceptance__body">
          <div class="quote-acceptance__body-item">
            <InfoAboutSelectedCarrier
              :insurance="insurance"
              :carrier="carrier"
              :transportSelected="transportSelected"
              :isPickup="isPickup"
              :originalCarrierArray="originalCarrierArray"
              :aditionalInsurance="aditionalInsurance"
              :lineItems="lineItems"
            />
          </div>
          <div class="quote-acceptance__body-item">
            <el-collapse v-model="accessorialsTab">
              <el-collapse-item title="Accessorials" name="accessorials">
                <AccessorialsByType :accessorials="transportModalInfo.accesorials" :chosenLoad="chosenLoad"/>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div v-if="!isDrayage" class="quote-acceptance__body-item">
            <PortalNotes :note="portalNotes" />
          </div>
          <div v-if="isDrayage" class="quote-acceptance__body-item">
            <PortalNoteDrayage />
          </div>
          <div class="quote-acceptance__body-item" v-if="insurance">
            <InfoAboutInsurance :displayInsuranceValue="displayInsuranceValue" />
            <p class="mt-1">
              Commodities such as electronics, aircraft parts, fragile cargo, HHG, artworks,
              watches, motor vehicles, machinery and heavy equipment won´t fall under the general
              cargo category so we will need to requote accordingly. Also, shipments going to Mexico
              no matter the commodity, will need to be re-quoted as well.
            </p>
            <b><i>{{ $t("carriers.messageVendorInsurance") }} </i></b>
          </div>
          <div
            class="quote-acceptance__body-item"
            v-if="
              !this.tokenInfo.magaya_guid &&
              !this.tokenInfo.is_branded &&
              insurance &&
              (loyaltyTier == 'Diamond' || loyaltyTier == 'Diamond Plus')
            "
          >
            <ClaimBenefits v-model="enableLoyaltyInsurance" />
          </div>
          <div class="quote-acceptance__body-item" v-if="!tokenInfo.is_branded">
            <TermsAndConditionsVue />
          </div>
          <div class="quote-acceptance__body-item" v-if="showRecommendInsuranceAlert">
            <AlertInsuranceRecommend />
          </div>
           <div class="checkbox-container">
            <b-form-checkbox id="terms" v-model="confirmTermsAndConditions"/>
            <label for="terms">I have read and agreed to the Terms and Conditions</label>
           </div>
          <div class="quote-acceptance__body-item">
            <QuoteAcceptanceButtons
              :carrier="carrier"
              :lineItems="lineItems"
              :aditionalInsurance="aditionalInsurance"
              :isDropOffPickup="showPickupPrice"
              :isInsurance="insurance"
              :isInsuranceRecommend="transportSelected.insuranceAlert"
              :confirmTermsAndConditions="confirmTermsAndConditions"
              :originalCarrierArray="originalCarrierArray"
              @continueToTendering="continueToTendering"
            />
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import Checkbox from "primevue/checkbox";
import AccessorialsByType from "../../../../../components/AccessorialsByType.vue";
import TermsAndConditionsVue from "../../../shared/TermsAndConditions.vue";
import FormatEasyPostPrices from "../../../../../Extend/FormatEasyPostPrices";
import QuoteAcceptanceButtons from "./QuoteAcceptanceButtons.vue";
import AlertInsuranceRecommend from "./QuoteAcceptanceModal/AlertInsuranceRecommend.vue";
import InfoAboutSelectedCarrier from "./QuoteAcceptanceModal/InfoAboutSelectedCarrier.vue";
import InfoAboutInsurance from "./QuoteAcceptanceModal/InfoAboutInsurance.vue";
import ClaimBenefits from "./QuoteAcceptanceModal/ClaimBenefits.vue";
import PortalNotes from "./QuoteAcceptanceModal/PortalNotes.vue";
import PortalNoteDrayage from "./QuoteAcceptanceModal/PortalNoteDrayage.vue";

export default {
  name: "QuoteAcceptanceModal",
  components: {
    AccessorialsByType,
    TermsAndConditionsVue,
    QuoteAcceptanceButtons,
    AlertInsuranceRecommend,
    InfoAboutSelectedCarrier,
    InfoAboutInsurance,
    ClaimBenefits,
    PortalNotes,
    PortalNoteDrayage,
    // Checkbox
  },
  mixins: [FormatEasyPostPrices],
  props: {
    insurance: Boolean,
    aditionalInsurance: Number,
    showPickupPrice: Boolean,
    carrier: Object,
    lineItems: Array,
    originalCarrierArray: Array,
    isPickup: Boolean
  },
  data() {
    return {
      loading: false,
      accessorialsTab: ["accessorials"],

      transportSelected: {
        name: null,
        price: null,
        quoteNumber: null,
        portalNotes: null,
        insuranceAlert: null,
      },
      enableLoyaltyInsurance: false,
      tokenInfo: {},
      chosenLoad: {},
      confirmTermsAndConditions: false,
      isDrayage: this.$store.getters["load/getChosenLoad"]?.mode_name?.toLowerCase() === 'drayage'
    };
  },
  watch: {
    portalNotes: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.transportSelected.portalNotes = newValue;
        }
      }
    }
  },
  async created() {
    this.chosenLoad = this.$store.getters["load/getChosenLoad"];
    this.loyaltyTier = this.chosenLoad.loyalty_tier;
    this.tokenInfo = this.$store.getters["login/getTokenInfo"];
    if (this.transportModalInfo && this.transportModalInfo.selectedTransport) {
      this.transportSelected.name = this.transportModalInfo.selectedTransport.carrier;
      this.transportSelected.insuranceAlert =
      this.transportModalInfo.selectedTransport.insuranceAlert;
      if (this.insurance) {
      // eslint-disable-next-line max-len
        this.transportSelected.price = (
          this.transportModalInfo.selectedTransport.price + this.aditionalInsurance
        ).toFixed(2);
      } else {
        this.transportSelected.price = this.transportModalInfo.selectedTransport.price;
      }
      this.transportSelected.quoteNumber = this.transportModalInfo.selectedTransport.quoteNumber;
    }
  },
  computed: {
    ...mapGetters({
      transportModalInfo: "transportSelected/getTransportModalInformation",
      chosenLoadCargoValue: "carriers/getChosenLoadCargoValue",
      insuranceCoveragePlan: "carriers/getInsuranceCoveragePlan",
    }),
    showRecommendInsuranceAlert() {
      if (this.transportSelected.insuranceAlert && !this.insurance && !this.showPickupPrice) {
        return true;
      }
      return false;
    },
    displayInsuranceValue() {
      const cargoValue = Number(this.chosenLoadCargoValue);
      if (Number.isFinite(cargoValue) && cargoValue > 0) {
        return cargoValue;
      }
      const modalInsuranceValue = Number(this.transportModalInfo?.insurance);
      if (Number.isFinite(modalInsuranceValue) && modalInsuranceValue > 0) {
        return modalInsuranceValue;
      }
      const plan = `${this.insuranceCoveragePlan || ""}`.trim().toLowerCase();
      if (plan === "minimum") return 15000;
      if (plan === "basic") return 25000;
      return null;
    },
    portalNotes() {
      if (this.isDrayage) {
        return this.carrier?.portalNotes;
      }
      return this.transportModalInfo?.portalNotes;
    }
  },
  methods: {
    ...mapActions("carriers", ["updatedCarrierById"]),
    closeModal() {
      this.$emit("closeModal");
    },
    continueToTendering({ buyPickup, insurance }) {
      const { loadId } = this.$route.params;
      // eslint-disable-next-line no-underscore-dangle
      const selectedCarrierId = this.carrier?._id;

      if (!loadId || !selectedCarrierId) return;

      if (insurance) {
        const fee = Number(this.aditionalInsurance);
        const cargocareFee = Number.isFinite(fee) ? fee : 0;
        const cargoValue = this.$store.getters["carriers/getChosenLoadCargoValue"];
        const currentCargoValue = Number.isFinite(Number(cargoValue)) ? Number(cargoValue) : 0;
        const existingCargoValue = Number(this.chosenLoad?.cargo_value_for_insurance);
        const existingNormalized = Number.isFinite(existingCargoValue) ? existingCargoValue : 0;
        const body = {
          cargocare_insurance_selling_rate_amount: cargocareFee,
          ...(currentCargoValue !== existingNormalized && {
            cargo_value_for_insurance: currentCargoValue || null,
          }),
        };
        this.$store
          .dispatch("load/updateLoad", { id: loadId, body })
          .then(() => {
            this.$store.commit("load/modifyChosenLoadSpecificData", {
              key: "cargocare_insurance_selling_rate_amount",
              value: cargocareFee,
            });
            if (body.cargo_value_for_insurance !== undefined) {
              this.$store.commit("load/modifyChosenLoadSpecificData", {
                key: "cargo_value_for_insurance",
                value: currentCargoValue || null,
              });
            }
          })
          .catch(() => {});
      }

      this.$store.commit("carriers/resetCarriersList");

      // Quitar principalCarrier a otros carriers (solo si hay lista; p. ej. Drayage/Trucks no la envían)
      const carriersList = Array.isArray(this.originalCarrierArray)
        ? this.originalCarrierArray
        : [];

      carriersList.forEach((carrier) => {
        // eslint-disable-next-line no-underscore-dangle
        if (carrier.principalCarrier && carrier._id !== selectedCarrierId) {
          const payload = {
            loadId,
            // eslint-disable-next-line no-underscore-dangle
            carrierId: carrier?._id,
            body: {
              isBookPickup: false,
              isBookInsurance: false,
              principalCarrier: false
            },
          };
          this.updatedCarrierById(payload);
        }
      });
      const payload = {
        loadId,
        // eslint-disable-next-line no-underscore-dangle
        carrierId: selectedCarrierId,
        body: {
          isBookPickup: buyPickup,
          isBookInsurance: insurance,
          principalCarrier: true
        },
      };
      this.updatedCarrierById(payload);
      this.$emit("optionSelected", {
        enableLoyaltyInsurance: this.enableLoyaltyInsurance,
        buyPickup,
        insurance,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/Checkboxes.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
.close-button {
  @include modals-close-button;
}
.quote-acceptance {
  &__header {
    @include modals-header;
  }
  &-content {
    font-family: $font-family-portal;
  }
  &__selected-carrier {
    @include font-standart-text;
    margin-bottom: 0px;
  }
  &__title {
    @include modals-title;
  }
  &__body {
    display: flex;
    flex-direction: column;
    color: $color-primary-company;
    &-item {
      display: flex;
      flex-direction: column;
      width: 100%;
      text-align: start;
      margin: 5px 0px;
      span {
        font-weight: bold;
        margin: 10px 0px;
      }
    }
  }
}
hr {
  margin: 0;
}
::v-deep {
  .el-collapse {
    border: none;
  }
  .el-collapse-item__header {
    color: $color-primary-company;
    background-color: $color-gray-light;
    border: none;
    width: 100%;
    text-align: left;
    font-weight: bold;
    height: 30px;
    font-size: 16px !important;
  }
  .el-icon-arrow-right {
    color: $color-primary-company;
    font-weight: bold;
  }
  .el-collapse-item__content {
    background-color: $color-gray-light;
    @include font-standart-text;
    padding-bottom: 0%;
    border: none;
  }
  .el-collapse-item__wrap {
    border: none;
    background-color: $color-gray-light;
  }
}
.checkbox-container {
  display: flex;
  align-items: center;
  margin: 10px auto;
  label {
    margin-left: 10px;
    font-size: 15px;
    margin-bottom: 0px;
  }
}
::v-deep .spinner-border {
  color: $color-primary-company;
}
</style>
